import { TTasaViewModel } from "src/app/components/core/_infrastructure/types/common";
import { TwSolicitudJerarquiaViewModel } from "../datosbasicos/datosbasicos.types";

export class SolicitudTasasViewModel {
    constructor() {}

    public Id: number;
    public IdEstadoSolicitud = 0;
    public FechaCreacion: Date;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitud: number;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPredua: boolean;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public TTasaCollection: TTasaViewModel[];
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
}
